<template>
  <v-app-bar
    app
    fixed
    shrink-on-scroll
    :height="expandSearch ? '20px' : '150px'"
    flat
    fade-img-on-scroll
    extended
    :class="{ 'background-dark': isDark, 'background-light': !isDark }"
    :dark="isDark"
    :src="images.banner || ''"
  >
    <v-row
      class="d-flex justify-space-between align-center mb-3"
      justify="space-between"
      align="center"
    >
      <v-col cols="2">
        <v-avatar>
          <v-img :src="images.logo" max-height="40" max-width="40" contain />
        </v-avatar>
      </v-col>
      <v-col cols="10" align="right">
        <v-btn
          v-if="!expandSearch"
          icon
          @click="
            clickedSearch = true;
            expandSearch = true;
          "
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-text-field
          v-show="expandSearch"
          single-line
          flat
          clearable
          id="search"
          dense
          rounded
          solo
          ref="search"
          color="primary"
          prepend-inner-icon="search"
          v-model="searchBar"
          hide-details
          @focus="expandSearch = true"
          @blur="expandSearch = search ? true : false"
          :placeholder="$t('Search')"
          v-on:input="updateValue()"
          style="opacity:0.8;"
        />
      </v-col>
    </v-row>

    <template v-slot:img="{ props }">
      <v-img v-bind="props" aspect-ratio="2" :gradient="gradient">
        <div
          id="takeaway"
          class="primary--text"
          color="primary"
          v-if="isTakeAway"
        >{{ $t("Takeaway") }}</div>
      </v-img>
    </template>

    <template #extension>
      <v-tabs
        centered
        grow
        :dark="isDark"
        hide-slider
        :background-color="isDark ? '#1e1e1e' : 'white'"
        class="mt-7"
      >
        <div v-for="category in categories" :key="category.id">
          <v-tab
            v-if="category.name != ''"
            @click="$vuetify.goTo('#select' + category.id, { offset: 20 })"
          >{{ category.name }}</v-tab>
        </div>
      </v-tabs>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  name: "appBar",
  components: {},
  props: ["categories", "images", "search"],
  data: function() {
    return {
      searchBar: "",
      expandSearch: false,
      clickedSearch: false
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", this.searchBar);
    },

    collapseSearchField() {
      this.expandSearch = false;
    }
  },
  computed: {
    isTakeAway() {
      if (this.$store.state._locationObject) {
        return this.$store.state._locationObject.isTakeAway;
      } else {
        return false;
      }
    },
    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    },
    gradient: function() {
      if (this.isDark) {
        return "to bottom, rgba(255, 255, 255, 0.0), #1e1e1e 84%";
      } else {
        return "to bottom, rgba(255, 255, 255, 0.0), white 82%";
      }
    }
  },
  watch: {
    clickedSearch(value) {
      if (value) {
        this.$nextTick(() => {
          this.$refs.search.focus();
        });
      }
    },
    search(value) {
      if (value) {
        this.expandSearch = true;
      }
    }
  },
  mounted() {
    if (this.search) {
      this.expandSearch = true;
    }
    const collapseSearchField = this.collapseSearchField;
    window.onpopstate = function() {
      collapseSearchField();
    };
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Architects+Daughter&display=swap");

#takeaway {
  font-family: "Architects Daughter", cursive;
  transform: rotate(-10deg);
  bottom: 45px;
  right: 5px;
  position: absolute;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
  transition-property: width;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.background-dark {
  background-color: #1e1e1e !important;
}
.background-light {
  background-color: white !important;
}
</style>
